import React from "react";
import styles from "./ClientForm.module.css";

function ProgressBar({ step, totalSteps }) {
  const percent = (step / totalSteps) * 100;

  const labels = ["Purchase", "Applicant", "Income", "Liabilities", "Submit"];

  return (
    <div className={styles.progressWrapper}>
      {/* Progress bar */}
      <div className={styles.progressTrack}>
        <div
          className={styles.progressBar}
          style={{ width: `${percent}%` }}
        />
      </div>

      {/* Step text */}
      <p className={styles.progressText}>
        Step {step} of {totalSteps}: {labels[step - 1]}
      </p>

      {/* Step labels */}
      <div className={styles.progressLabels}>
        {labels.map((label, index) => (
          <span
            key={label}
            className={`${styles.progressLabel} ${
              step === index + 1 ? styles.activeLabel : ""
            }`}
          >
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}

export default ProgressBar;
